class AboutPicker extends HTMLElement {
  connectedCallback() {
    this.addEventListener('click', this);
  }

  handleEvent({ target }) {
    const button = target.closest('[data-picker-target]');
    if (!button) return;

    for (const item of this.querySelectorAll('[data-picker-target]')) {
      item.setAttribute('aria-pressed', String(item === button));
    }
    for (const panel of this.querySelectorAll('[data-picker-panel]')) {
      panel.hidden = panel.id !== button.dataset.pickerTarget;
    }
  }
}

if (!customElements.get('about-picker')) customElements.define('about-picker', AboutPicker);
